import styled from 'styled-components';

export const Image = styled.img.attrs({
  alt: 'Preview file'
})`
  width: 100%;
  height: 100%;
  border-radius: 8px;
`;
